module.exports = __webpack_public_path__ + "static/media/main.0e2d2f7c.png";